import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "verify-email-page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import {showErrorAlert, showSuccessAlert} from "@/helpers/SweetAlertHelper";
import SimpleLayout from "@/layouts/simple/SimpleLayout.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerifyEmailPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const verifying = ref(true);
const success = ref(false);

onMounted(async () => {
  const token = route.query.token as string;

  if (!token) {
    showErrorAlert("Token inválido o expirado.");
    verifying.value = false;
    return;
  }

  try {
    const response = await EmailVerification.verifyEmail({
      token,
    });

    if (response.status === "OK") {
      showSuccessAlert("¡Hola!", "Tu correo ha sido verificado con éxito.");
      success.value = true;
      router.push({name: "login"});
    } else {
      showErrorAlert("El enlace de verificación ha expirado o es inválido.");
      router.push({name: "login"});
    }
  } catch (error) {
    showErrorAlert("Error verificando el correo.");
    router.push({name: "login"});
  } finally {
    verifying.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleLayout, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (verifying.value)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Verificando tu correo..."))
          : (success.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "Correo verificado con éxito. Redirigiendo..."))
            : (_openBlock(), _createElementBlock("h2", _hoisted_4, "Error verificando el correo."))
      ])
    ]),
    _: 1
  }))
}
}

})